module.exports = __webpack_public_path__ + "img/insider_banner_dektop_2x.dbc609b4.png";